import { AxiosError } from 'axios';
import { useRouter } from 'next/router';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { cartService } from 'services';
import { AssignTemplateToOrderParams } from 'types';
import { displayNotification } from 'utils';

export const useAssignTemplateToOrder = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  return useMutation(
    ({ templateCode }: AssignTemplateToOrderParams) => {
      return cartService.assignTemplateToOrder(templateCode);
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification('Design selected successfully', 'success');
        queryClient.setQueriesData([ServerStateKeysEnum.userCurrentCart], data);
        router.push('/customcase/selectcasequantity');
      },
      onError: (err: AxiosError<{ error: string }>) => {
        displayNotification(
          'Failed to select the template for the order',
          'danger'
        );
        router.push('/customcase/selectcasequantity');
      },
    }
  );
};
